import { Notification } from "@drone-js/core";
import { useStaticDataAtomValue } from "../../staticDataAtom";

export const AddNewAccountNotification = () => {
    const {
        cmsData: {
            pricing: { youCanAddYourNewAccount },
        },
    } = useStaticDataAtomValue();

    return (
        <Notification
            intent="notice"
            title={youCanAddYourNewAccount}
            asset={{
                id: "fill.symbol.circle-info",
            }}
        />
    );
};
